/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { Model401ErrorResponse } from '../models/models';
import { Model403ErrorResponse } from '../models/models';
import { Model500ErrorResponse } from '../models/models';
import { Szma301aRequest } from '../models/models';
import { Szma301aResponse } from '../models/models';

import { FF_API_BASE_PATH, FF_API_COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class SZMA301AService {

  protected basePath = 'https://example.swagger.io/api/v1/ff';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(protected httpClient: HttpClient, @Optional()@Inject(FF_API_BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
      if (configuration) {
          this.configuration = configuration;
      }
      if (typeof this.configuration.basePath !== 'string') {
          if (typeof basePath !== 'string') {
              basePath = this.basePath;
          }
          this.configuration.basePath = basePath;
      }
      this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }


  private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
      if (typeof value === "object" && value instanceof Date === false) {
          httpParams = this.addToHttpParamsRecursive(httpParams, value);
      } else {
          httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
      }
      return httpParams;
  }

  private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
      if (value == null) {
          return httpParams;
      }

      if (typeof value === "object") {
          if (Array.isArray(value)) {
              (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
          } else if (value instanceof Date) {
              if (key != null) {
                  httpParams = httpParams.append(key,
                      (value as Date).toISOString().substr(0, 10));
              } else {
                 throw Error("key may not be null if value is Date");
              }
          } else {
              Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                  httpParams, value[k], key != null ? `${key}.${k}` : k));
          }
      } else if (key != null) {
          httpParams = httpParams.append(key, value);
      } else {
          throw Error("key may not be null if value is not object or array");
      }
      return httpParams;
  }

  /**
   * 契約情報取得（ガス）
   * ガスの契約詳細情報を取得する。
   * @param szma301aRequest 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public c13RSZMA301APost(szma301aRequest?: Szma301aRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Szma301aResponse>;
  public c13RSZMA301APost(szma301aRequest?: Szma301aRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Szma301aResponse>>;
  public c13RSZMA301APost(szma301aRequest?: Szma301aRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Szma301aResponse>>;
  public c13RSZMA301APost(szma301aRequest?: Szma301aRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

      let headers = this.defaultHeaders;

      let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
      if (httpHeaderAcceptSelected === undefined) {
          // to determine the Accept header
          const httpHeaderAccepts: string[] = [
              'application/json'
          ];
          httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (httpHeaderAcceptSelected !== undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }


      // to determine the Content-Type header
      const consumes: string[] = [
          'application/json'
      ];
      const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
          headers = headers.set('Content-Type', httpContentTypeSelected);
      }

      let responseType_: 'text' | 'json' = 'json';
      if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
      }

      return this.httpClient.post<Szma301aResponse>(`${this.configuration.basePath}/C13/R/SZMA301A`,
          szma301aRequest,
          {
              responseType: <any>responseType_,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
  }

}
